var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Photoswipe',{class:_vm.template},_vm._l((_vm.photos),function(src,index){return _c('div',{key:index,staticClass:"photoswipe-image"},[_c('img',{staticClass:"lazy",attrs:{"data-src":src,"data-pswp-src":src}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }